import YAlert from './Alert';

export { YAlert };
export default YAlert;
